module.exports = __webpack_public_path__ + "img/phones-lg@2x.7051135e.png";